import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
// Material imports
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close"; // Limitless imports

import { ClientContext } from "../../../common/utils";
import { withi18n } from "../hocs/i18n";

var Header = /*#__PURE__*/function (_PureComponent) {
  _inherits(Header, _PureComponent);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderLeftIcon = function () {
      var _this$props = _this.props,
          onLeftIconClickHandle = _this$props.onLeftIconClickHandle,
          leftIcon = _this$props.leftIcon,
          t = _this$props.t,
          classes = _this$props.classes;
      var style;

      if (!onLeftIconClickHandle) {
        style = {
          visibility: "hidden"
        };
      }

      return /*#__PURE__*/React.createElement(IconButton, {
        color: "inherit",
        onClick: _this.props.onLeftIconClickHandle,
        style: style,
        component: "div",
        "aria-label": leftIcon ? t("Messenger Help") : t("Conversation History"),
        classes: {
          root: classes.iconButton
        }
      }, leftIcon ? leftIcon : /*#__PURE__*/React.createElement(Menu, null));
    };

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          onCloseHandle = _this$props2.onCloseHandle,
          t = _this$props2.t,
          fullScreen = _this$props2.fullScreen;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AppBar, {
        position: "static",
        classes: fullScreen ? {} : {
          root: classes.root
        },
        elevation: 0
      }, /*#__PURE__*/React.createElement(Toolbar, {
        classes: {
          root: classes.toolbarGutters
        },
        disableGutters: true
      }, this.renderLeftIcon(), /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        color: "inherit",
        component: "div"
      }, t(this.props.title)), /*#__PURE__*/React.createElement(IconButton, {
        color: "inherit",
        "aria-label": t("Close Messenger"),
        onClick: onCloseHandle,
        classes: {
          root: classes.iconButton
        },
        component: "div"
      }, /*#__PURE__*/React.createElement(Close, null)))));
    }
  }]);

  return Header;
}(PureComponent);

var styles = function styles() {
  var headerStyles = {
    "@media screen and (min-width: 450px)": {
      root: {
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)"
      }
    },
    toolbarGutters: {
      flex: 1,
      justifyContent: "space-between"
    },
    menuIconHide: {
      width: "48px"
    }
  };

  if (!ClientContext._headerButtonHoverEnabled) {
    headerStyles.iconButton = {
      "&:hover": {
        backgroundColor: "transparent"
      }
    };
  }

  return headerStyles;
};

export default withStyles(styles)(withi18n(Header));